/**
 * PrivacyPage - 隐私政策页。
 * 复用 LegalPage 布局，内容走 i18n legal.privacy。
 */
import LegalPage from "./LegalPage";

export default function PrivacyPage() {
  return <LegalPage i18nKey="legal.privacy" />;
}
